// extracted by mini-css-extract-plugin
export var active = "_cm-2";
export var recordingDot = "_cm-1";
export var recordingIndicator = "_cm-0";